var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 2.91672H5.83341C3.33341 2.91672 1.66675 4.16672 1.66675 7.08338V12.9167C1.66675 15.8334 3.33341 17.0834 5.83341 17.0834H14.1667C16.6667 17.0834 18.3334 15.8334 18.3334 12.9167V7.08338C18.3334 4.16672 16.6667 2.91672 14.1667 2.91672ZM14.5584 7.99172L11.9501 10.0751C11.4001 10.5167 10.7001 10.7334 10.0001 10.7334C9.30008 10.7334 8.59175 10.5167 8.05008 10.0751L5.44175 7.99172C5.17508 7.77505 5.13341 7.37505 5.34175 7.10838C5.55841 6.84172 5.95008 6.79172 6.21675 7.00838L8.82508 9.09172C9.45841 9.60005 10.5334 9.60005 11.1667 9.09172L13.7751 7.00838C14.0417 6.79172 14.4417 6.83338 14.6501 7.10838C14.8667 7.37505 14.8251 7.77505 14.5584 7.99172Z",
    fill: "#009B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/Icon_mail.6071c16cde39b6bd75c64d22384b1603.svg";
export { ForwardRef as ReactComponent };